import type { FC } from "react";
import { useEffect, useState } from "react";

import Balloon from "@Components/Balloon";
import { getFromUrl, removeFromUrl } from "@Components/Modules/Helpers";
import { cashbackTooltipMessage } from "@Constants/PortalConstants";

import * as css from "./CashbackTooltip.module.css";

export interface ICashbackTooltip {
    title: string;
    description: string;
    visibilityTime?: number;
    onClose?: () => void;
}

const CashbackTooltip: FC<ICashbackTooltip> = (props) => {
    const [isOpen, setOpen] = useState(true);

    useEffect(() => {
        if (getFromUrl(cashbackTooltipMessage)) {
            removeFromUrl(cashbackTooltipMessage);
        }

        const timer = setTimeout(() => {
            setOpen(false);
            if (props.onClose) {
                props.onClose();
            }
        }, props.visibilityTime || 5000);

        return () => clearTimeout(timer);
    }, []);

    return (
        <div className={css.cashbackTooltipComponent}>
            <Balloon isOpen={isOpen} tailPosition="BottomCenter">
                <div className={css.tooltipMessage}>
                    <p className={css.title} dangerouslySetInnerHTML={{ __html: props.title }} />
                    <p className={css.description} dangerouslySetInnerHTML={{ __html: props.description }} />
                </div>
            </Balloon>
        </div>
    );
};

export default CashbackTooltip;
